export const SUBSCRIPTION_OPTIONS = {
    annual: "Annually",
    monthly: "Monthly",
  };

export const COUPON_TYPES = {
  price: '$',
  percent: '%',
}
  
export const SUBSCRIPTION_VALUES = {
    Monthly: { development: 'price_1IW3j52BakUKU8Rt1My02bUW', production: 'gobox-subscription-monthly-tiered'},
    Annually: { development: 'price_1IWPGk2BakUKU8Rt4WOzd8g8', production: 'gobox-subscription-annual-tiered'}
  }
  
export const getSubscription = (subscription) => {
    if(subscription.split('-')[2] > 0) {
      return subscription.split('-')[2];
    } else if (subscription === SUBSCRIPTION_VALUES.Monthly[process.env.REACT_APP_ENV]) {
      return 'Monthly';
    } else if(subscription === SUBSCRIPTION_VALUES.Annually[process.env.REACT_APP_ENV]) {
      return 'Annual';
    } else {
      return '';
    }
  }

export const tableRows = [
    [{ value: "Credits" }, { value: "Monthly" }, { value: "Annual" }],
    [{ value: "1 Credit" }, { value: 3.95 }, { value: 21.95 }],
    [{ value: "2 Credits" }, { value: 5.0 }, { value: 30.0 }],
    [{ value: "3 Credits" }, { value: "N/A"}, { value: 35.0 },],
    [{ value: "4 Credits" },{ value: "N/A" }, { value: 40.0 },
    ],
  ];